<template>
  <div>
    <base-profile />
    <div class="container-profile pb-5">
      <profile-mis-pedidos />
    </div>
  </div>
</template>
<script>
import BaseProfile from '@/components/profile/BaseProfile'
import ProfileMisPedidos from '@/components/profile/ProfileMisPedidos'
export default {
  components: { BaseProfile, ProfileMisPedidos },
  // mounted() {
  //     document.title = 'Perfil | DEREK Tienda Online'
  //     this.$gtag.pageview(this.$route.fullPath);
  // },
}
</script>
